module.exports = __webpack_public_path__ + "static/video-home-d6b8b8f3be6f52193a53f32c9ccb0ff6.mp4";